
import XButton from 'vux/src/components/x-button/index.vue'
import CheckIcon from 'vux/src/components/check-icon/index.vue'

export default {
props: {
disabled: {
type: [Boolean],
default: false
},
investerType: {
type: [Number],
default: 1003
}
},
components: {
XButton,
CheckIcon
},
methods: {
checkEvent () {
let isEmit = this.disabled
if (isEmit) {
return
} else {
this.$emit('click')
}
}
}
}



// WEBPACK FOOTER //
// ./src/components/baseComponents/SubmitButton.vue